import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step1Name: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-grid">
      <div className="solar-form-group">
        <label htmlFor="firstName" className="solar-form-label">
          First Name
        </label>
        <input
          type="text"
          id="firstName"
          {...register('firstName')}
          className="solar-form-input"
        />
        {errors.firstName && (
          <p className="solar-form-error">{String(errors.firstName.message)}</p>
        )}
      </div>

      <div className="solar-form-group">
        <label htmlFor="lastName" className="solar-form-label">
          Last Name
        </label>
        <input
          type="text"
          id="lastName"
          {...register('lastName')}
          className="solar-form-input"
        />
        {errors.lastName && (
          <p className="solar-form-error">{String(errors.lastName.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step1Name; 